'use client';
import { useTheme } from '@/components/ThemeComponents/ThemeProvider';
import Image, { ImageProps } from 'next/image';
import React, { useEffect, useState } from 'react';

export function DynamicLogoImage(props: Omit<ImageProps, 'src' | 'alt'>) {
  const themeData = useTheme();
  const logoImageKey = themeData?.application?.logoImageKey;
  const backgroundImageKey = themeData?.application?.backgroundImageKey;
  const [imageLogo, setImageLogo] = useState<string>('/imgs/img_loading.gif');
  const [isLoading, setIsLoading] = useState(true);

  const { width = 250, height = 250, style, ...rest } = props;

  useEffect(() => {
    // ✅ ทำงานเฉพาะในฝั่ง client เท่านั้น
    const theme = localStorage.getItem('hostTheme');

    if (theme) {
      if (logoImageKey) {
        // ถ้ามี logo จาก themeData ให้ใช้โลโก้นั้น
        setImageLogo(logoImageKey);
      } else {
        // ถ้าไม่มี logoImageKey ให้ใช้โลโก้ default
        setImageLogo('/imgs/icon2.1.png');
      }
      setIsLoading(false);
    } else {
      // ถ้ายังไม่มี theme ใน localStorage ให้โชว์ loading ไปก่อน
      setIsLoading(true);
    }
  }, [logoImageKey]);

  if (isLoading) {
    return (
      <Image
        src="/imgs/img_loading.gif"
        alt="Dynamic Logo"
        width={50}
        height={50}
        style={{ objectFit: 'contain', ...style }}
        {...rest}
      />
    );
  }

  return (
    <Image
      src={imageLogo}
      alt="Dynamic Logo"
      width={width}
      height={height}
      style={{ objectFit: 'contain', ...style }}
      {...rest}
    />
  );
}
